import { atom } from 'nanostores';

export type Theme = 'dark' | 'light';

export const kTheme = 'dunea_theme';

export function themeIsDark() {
  return themeStore.get() === 'dark';
}

export const DEFAULT_THEME = 'dark';

export const themeStore = atom<Theme>('dark');

export function toggleTheme() {
  // Dark mode locked — no-op
}

/**
 * Animated theme toggle using the View Transitions API.
 * Creates a circular reveal animation from the given element.
 */
export function animatedToggleTheme(_originElement?: HTMLElement | null, _duration = 400) {
  // Dark mode locked — no-op
}

/**
 * Apply a theme loaded from the server (called during preferences init).
 * Only applies if it differs from the current localStorage fast-path value.
 */
export function applyServerTheme(_theme: Theme) {
  // Dark mode locked — ignore server preference
}
